import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_HIDE_SIGNEES = createFcmDetails('hide_signees', {
	owner: 'supporters pack',
	context: 'petition page',
	description: `Indicates whether signees must be hidden.
			This impacts comments (reasons for signing), recent signers, and the recruiter.
			If user's country (or locale) or the petition's country match, they will not be visible.
			Related FCM: petition_display_recruiter_name
		`,
	import: false,
});
